import React, { useState } from 'react';
import {
    Box,
    Typography,
    Collapse,
    Paper,
    IconButton
} from '@mui/material';
import RadioButtonCheckedIcon from '@mui/icons-material/RadioButtonChecked';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

// Helper: parse time string like "06:00 am" to Date object today
function parseTimeToDate(timeStr) {
    const [time, meridian] = timeStr.split(' ');
    let [hours, minutes] = time.split(':').map(Number);
    if (meridian.toLowerCase() === 'pm' && hours !== 12) {
        hours += 12;
    }
    if (meridian.toLowerCase() === 'am' && hours === 12) {
        hours = 0;
    }
    const now = new Date();
    return new Date(now.getFullYear(), now.getMonth(), now.getDate(), hours, minutes);
}

export function StopItemWithDetails({ stop, isSelected, frequencies = [] }) {
    const [expanded, setExpanded] = useState(false);

    const handleToggle = () => {
        if (isSelected) {
            setExpanded(prev => !prev);
        }
    };

    const now = new Date();

    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                zIndex: 1,
                cursor: isSelected ? 'pointer' : 'default',
            }}
        >
            <Box
                sx={{ display: 'flex', alignItems: 'center' }}
                onClick={handleToggle}
            >
                <RadioButtonCheckedIcon fontSize="small" sx={{ mr: 1, color: isSelected ? "black" : "orange" }} />
                <Typography
                    variant={isSelected ? "body1" : "body2"}
                    fontWeight={isSelected ? 'bold' : 'normal'}
                    sx={{
                        flexGrow: 1,
                        fontSize: isSelected ? '1.25rem' : '0.9rem',
                    }}
                >
                    <strong>{stop.stop_name}</strong>
                </Typography>
                {isSelected && (
                    <IconButton
                        size="small"
                        onClick={handleToggle}
                        sx={{
                            transform: expanded ? 'rotate(180deg)' : 'rotate(0deg)',
                            transition: 'transform 0.2s ease-in-out',
                        }}
                    >
                        <ExpandMoreIcon />
                    </IconButton>
                )}
            </Box>

            <Collapse in={expanded}>
                <Paper
                    elevation={2}
                    sx={{
                        mt: 1,
                        ml: 4,
                        p: 2,
                        bgcolor: '#f9f9f9',
                    }}
                >
                    <Typography variant="body2" gutterBottom>
                        🕒 <strong>Upcoming Arrival:</strong> 5 mins
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        🚍 <strong>Bus Plate:</strong> WSP 1234
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        ⏱ <strong>Time Away:</strong> 3 mins
                    </Typography>
                    <Typography variant="body2" gutterBottom>
                        📍 <strong>Stops Away:</strong> 2
                    </Typography>

                    {frequencies.length > 0 ?
                        <Box mt={2}>
                            <Typography variant="body2" fontWeight="bold" gutterBottom>
                                Scheduled:
                            </Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                                {frequencies.map((timeStr, i) => {
                                    const timeDate = parseTimeToDate(timeStr);
                                    const isPast = timeDate < now;
                                    return (
                                        <Typography
                                            key={i}
                                            variant="body2"
                                            sx={{
                                                color: isPast ? 'text.disabled' : 'text.primary',
                                                userSelect: 'none',
                                            }}
                                        >
                                            {timeStr}
                                            {i < frequencies.length - 1 && ' |'}
                                        </Typography>
                                    );
                                })}
                            </Box>
                        </Box> :
                        null}
                </Paper>
            </Collapse>
        </Box>
    );
}
